// extracted by mini-css-extract-plugin
module.exports = {"recommender":"Rq-z"};